import IVehicle from 'src/types/hr_ticket/vehicle.type';
import { http } from '@martech-solution/utils/utils';

const controller = 'hr/vehicles';

export const getVehiclesDropdown = async (vehicleTypeId?: number) => {
  return http.get<IVehicle[]>(`${controller}/dropdown/${vehicleTypeId}`);
};
